var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g3, _path24, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 152,
    viewBox: "0 0 159 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4216 147.337C117.674 147.337 149.494 115.517 149.494 76.2644C149.494 37.0121 117.674 5.19189 78.4216 5.19189C39.1693 5.19189 7.34912 37.0121 7.34912 76.2644C7.34912 115.517 39.1693 147.337 78.4216 147.337Z",
    fill: "#DCE8F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.505 52.9252C127.495 52.7122 127.479 52.4993 127.468 52.281C127.468 52.281 111.986 54.123 95.0674 47.5641C109.585 53.5534 123.326 53.2074 127.505 52.9252Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.574 52.8131C28.574 52.8131 56.5132 56.1404 78.3407 37.9491C78.0106 37.6829 77.6806 37.4114 77.3558 37.1345C55.4804 55.6453 27.2431 52.2807 27.2431 52.2807C22.7977 123.997 54.6605 145.213 69.7428 151.202C69.8546 151.244 69.9664 151.282 70.0782 151.324C54.6339 144.808 23.5856 123.646 28.574 52.8131Z",
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2988 134.212L66.3615 51.9139L109.527 78.3632L44.2988 134.212Z",
    fill: "#FC6D5B",
    stroke: "#262626",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_551_4654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 55,
    width: 57,
    height: 72
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7821 125.938C50.0357 126.577 48.9113 125.869 49.1657 124.92L67.6464 55.9369C67.8194 55.2912 68.5651 54.9937 69.135 55.3431L105.306 77.5167C105.885 77.8714 105.95 78.6873 105.434 79.1288L50.7821 125.938Z",
    fill: "#DA4540"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_551_4654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.114 94.8488L106.407 90.9233C106.308 90.8679 96.184 85.1099 85.7218 76.9276C72.1554 66.3224 64.1524 56.5151 62.5737 48.5703L58.0793 49.4629C62.3517 70.9866 102.414 93.8839 104.114 94.8488Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4495 113.656L95.7421 109.731C95.6432 109.675 85.5195 103.917 75.0572 95.735C61.4909 85.1299 53.4878 75.3226 51.9092 67.3778L47.4147 68.2703C51.6872 89.794 91.749 112.691 93.4495 113.656Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8484 131.124L85.141 127.198C85.0421 127.143 74.9184 121.385 64.4562 113.203C50.8898 102.598 42.8867 92.7903 41.3081 84.8455L36.8136 85.7381C41.0861 107.262 81.1479 130.159 82.8484 131.124Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9036 146.626L72.1962 142.7C72.0973 142.645 61.9736 136.887 51.5113 128.705C37.945 118.1 29.9419 108.292 28.3633 100.347L23.8688 101.24C28.1413 122.764 68.2031 145.661 69.9036 146.626Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.655 90.4058L107.419 89.0973C107.015 88.8707 66.8545 65.918 62.8511 45.7288L61.3534 46.0286C63.0972 54.8215 71.2721 64.9722 85.6405 76.1948C96.2831 84.506 106.556 90.3504 106.655 90.4058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9883 109.214L96.7525 107.905C96.3487 107.678 56.188 84.7257 52.1846 64.5366L50.6869 64.8363C52.4307 73.6292 60.6056 83.7799 74.974 95.0026C85.6166 103.314 95.8894 109.158 95.9883 109.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3891 126.681L86.1533 125.373C85.7495 125.146 45.5888 102.193 41.5855 82.0043L40.0878 82.304C41.8315 91.0969 50.0065 101.248 64.3749 112.47C75.0175 120.781 85.2903 126.626 85.3891 126.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4521 142.181L73.2163 140.873C72.8125 140.646 32.6518 117.693 28.6485 97.5043L27.1508 97.804C28.8945 106.597 37.0695 116.748 51.4379 127.97C62.0805 136.281 72.3533 142.126 72.4521 142.181Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M52.8465 116.56C57.4934 115.713 61.4023 112.327 64.5314 108.898C67.6696 105.453 70.5061 101.738 73.6192 98.2668C81.2813 89.7366 86.4449 83.2115 93.9636 74.5509L106.03 78.2103L50.2297 126.274C49.4797 126.92 48.3474 126.2 48.614 125.247L51.0214 116.637C51.6023 116.694 52.2096 116.672 52.8465 116.56Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0119 69.5254L86.0116 69.5252C79.5158 65.9579 74.081 62.0197 70.541 58.5592C68.7656 56.8238 67.5099 55.2499 66.8215 53.9401C66.111 52.588 66.1313 51.7765 66.383 51.3321C66.6384 50.8812 67.3418 50.4339 68.8912 50.3192C70.3902 50.2082 72.4139 50.4355 74.8474 51.0126C79.7005 52.1635 85.9602 54.651 92.4524 58.219L92.4527 58.2192C98.9485 61.7865 104.383 65.7247 107.923 69.1852C109.699 70.9206 110.954 72.4944 111.643 73.8042C112.353 75.1564 112.333 75.9679 112.081 76.4123C111.826 76.8632 111.122 77.3105 109.573 77.4252C108.074 77.5361 106.05 77.3089 103.617 76.7318C98.7637 75.5809 92.5041 73.0933 86.0119 69.5254Z",
    fill: "#FFB800",
    stroke: "#262626",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3 66.6573C100.3 66.6573 123.016 54.4286 115.829 49.2609C108.642 44.0931 109.119 60.071 100.3 66.6573Z",
    fill: "#2FBF71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4899 60.094C84.4899 60.094 77.0785 21.9749 90.2365 25.2608C103.389 28.5549 83.8159 43.5023 84.4899 60.094Z",
    fill: "#FC6D5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4061 47.2243C100.844 46.7823 106.763 43.8563 109.063 38.7032C110.28 35.9802 109.966 32.218 107.04 30.6686C102.536 28.2821 99.0841 35.4348 104.378 36.7195C110.295 38.1523 114.903 30.6857 115.683 25.9577C116.528 20.8821 115.508 15.7292 116.561 10.6554C116.724 9.85987 117.958 10.1661 117.794 10.9549C116.102 19.1155 119.362 28.4408 112.39 34.9026C110.078 37.0467 106.599 38.926 103.4 37.7225C101.137 36.872 99.5535 34.5338 100.484 32.1598C101.438 29.7023 104.425 28.3748 106.905 29.2323C109.59 30.1638 111.12 33.0881 111.077 35.7909C110.942 43.3122 102.022 47.9446 95.4343 48.4793C94.6161 48.5458 94.5948 47.2892 95.4061 47.2243Z",
    fill: "#FFB800"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.766 50.4104C141.691 53.7811 141.211 57.9709 138.573 60.4427C137.184 61.749 134.824 62.3501 133.238 60.9144C130.795 58.701 134.394 55.1095 136.337 58.035C138.511 61.3027 134.972 65.6524 132.264 67.1199C129.36 68.6932 125.991 69.169 123.137 70.8708C122.689 71.1359 123.148 71.8153 123.595 71.5502C128.194 68.8119 134.588 68.8203 136.994 63.247C137.793 61.4023 138.173 58.9081 136.739 57.2332C135.724 56.0503 133.952 55.5862 132.705 56.6434C131.418 57.7395 131.269 59.8183 132.328 61.1346C133.486 62.5602 135.607 62.8662 137.239 62.2662C141.79 60.5996 142.646 54.2451 141.528 50.159C141.389 49.6556 140.622 49.9021 140.756 50.4103L140.766 50.4104Z",
    fill: "#FFB800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3714 19.6367L94.5322 17.5608L98.0392 18.9491L97.0358 15.3445L99.4752 12.4697L95.6911 12.3211L93.6893 9.15732L92.3572 12.6649L88.6804 13.5832L91.6392 15.9046L91.3714 19.6367Z",
    fill: "#FFB800"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.995 52.0041L128.473 49.4482L131.43 49.1835L129.428 47.026L130.105 44.1713L127.402 45.3913L124.86 43.8887L125.187 46.7975L122.942 48.728L125.846 49.3043L126.995 52.0041Z",
    fill: "#FFB800"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7935 56.6122C78.7935 56.6122 65.1643 35.0441 74.0204 33.9981C82.8765 32.9521 74.4224 46.6339 78.7935 56.6122Z",
    fill: "#0056D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.037 68.9706C116.072 70.2878 117.192 71.3216 118.525 71.2723C119.858 71.2297 120.912 70.1173 120.869 68.8017C120.834 67.4845 119.714 66.4507 118.382 66.5C117.048 66.5426 115.995 67.655 116.037 68.9706Z",
    fill: "#FFB800"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1515 16.106C72.1867 17.4232 73.3066 18.457 74.6388 18.4077C75.9725 18.3651 77.0258 17.2527 76.9837 15.9371C76.9485 14.62 75.8286 13.5861 74.4964 13.6355C73.1627 13.6781 72.1094 14.7904 72.1515 16.106Z",
    fill: "#0056D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.246 54.5725C100.27 55.3679 100.944 55.9933 101.749 55.9651C102.555 55.937 103.192 55.2669 103.168 54.4716C103.145 53.6762 102.47 53.0508 101.665 53.079C100.859 53.1071 100.222 53.7771 100.246 54.5725Z",
    fill: "#FFB800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1076 27.3201C76.1314 28.1155 76.8059 28.7409 77.6113 28.7127C78.4167 28.6846 79.0538 28.0146 79.0301 27.2192C79.0064 26.4238 78.3318 25.7984 77.5264 25.8266C76.7211 25.8547 76.0839 26.5248 76.1076 27.3201Z",
    fill: "#FFB800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.567 64.3265C129.591 65.1219 130.265 65.7473 131.071 65.7191C131.876 65.691 132.513 65.021 132.49 64.2256C132.466 63.4302 131.791 62.8048 130.986 62.833C130.181 62.8612 129.543 63.5312 129.567 64.3265Z",
    fill: "#0056D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.828 31.9636L124.663 31.0745L126.994 32.8804L127.035 29.9444L129.504 28.3028L126.691 27.3725L125.883 24.5596L124.109 26.9208L121.142 26.8265L122.857 29.2055L121.828 31.9636Z",
    fill: "#FFB800"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4109 51.8422C27.4109 51.8422 -4.10497 46.7607 1.62256 39.433C7.36082 32.1128 21.4833 51.8424 27.4109 51.8422Z",
    fill: "#FFB800"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1031 55.1745C26.1031 55.1745 4.99054 60.5605 6.64079 54.3873C8.29105 48.2141 22.3922 56.7919 26.1031 55.1745Z",
    fill: "#FFB800"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.068 47.8816C28.068 47.8816 8.78522 37.4786 14.1149 34.0539C19.4355 30.6309 24.2391 46.5446 28.068 47.8816Z",
    fill: "#FFB800"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_551_4654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 143,
    height: 143
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4201 147.337C117.672 147.337 149.493 115.517 149.493 76.2644C149.493 37.0121 117.672 5.19189 78.4201 5.19189C39.1679 5.19189 7.34766 37.0121 7.34766 76.2644C7.34766 115.517 39.1679 147.337 78.4201 147.337Z",
    fill: "#47EBE0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_551_4654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_551_4654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: -3,
    width: 112,
    height: 136
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4279 132.881L5.47363 117.733L96.5622 -2.25378L116.517 12.8942L25.4279 132.881Z",
    fill: "url(#paint0_linear_551_4654)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_551_4654)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.4279 132.881L5.47363 117.733L96.5622 -2.25372L116.517 12.8943L25.4279 132.881Z",
    fill: "url(#paint1_linear_551_4654)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_551_4654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 27,
    width: 103,
    height: 129
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2756 155.831L40.3384 147.531L131.427 27.5378L142.358 35.8379L51.2756 155.831Z",
    fill: "url(#paint2_linear_551_4654)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_551_4654)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.2766 155.831L40.3394 147.531L131.428 27.5378L142.359 35.8379L51.2766 155.831Z",
    fill: "url(#paint3_linear_551_4654)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_551_4654",
    x1: 49.5937,
    y1: 6.91464,
    x2: 72.3943,
    y2: 123.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0996373,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5024,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_551_4654",
    x1: 49.5937,
    y1: 6.9147,
    x2: 72.3943,
    y2: 123.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_551_4654",
    x1: 80.7589,
    y1: 37.4298,
    x2: 101.941,
    y2: 145.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0996373,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5024,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_551_4654",
    x1: 80.7598,
    y1: 37.4298,
    x2: 101.942,
    y2: 145.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.caa095a4f86b9e59c2aca10658abffbd.svg";
export { ForwardRef as ReactComponent };